import React from 'react';
import {
  ThumbnailViewGrayIcon,
  ListViewGrayIcon,
  ThumbnailViewWhiteIcon,
  ListViewWhiteIcon,
} from 'asset/images';
import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { style, ViewMode } from 'commons/constants/KeyFlowConstants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#ffffff',
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    [theme.breakpoints.down('md')]: {
      height: '36px',
    },
  },
  labelContainer: {
    display: 'inline-block',
    padding: '0 10px 0 10px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '32px',
    height: '100%',
    textAlign: 'center',
    fontSzie: '14px',
    color: '#afafaf',
    fontWeight: 'bold',
    '& > img': {
      height: '60%',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  isActive: {
    backgroundColor: '#D94F98',
    color: '#ffffff',
    fontWeight: 'bold',
  },
}));

function SquareSwitchByAutoScroll({ onChange, value }: SwitchProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.labelContainer}>자동 스크롤</span>
      <span className={clsx(classes.iconContainer, value && classes.isActive)} onClick={onChange}>
        ON
      </span>
      <span className={clsx(classes.iconContainer, !value && classes.isActive)} onClick={onChange}>
        OFF
      </span>
    </div>
  );
}

export default SquareSwitchByAutoScroll;
